/**
 * Avatar 组件类型定义
 */

export type AccountLevelType = 'official' | 'officialQualityCreator' | 'brandDirector' | ''

export type AvatarSizeType = 'large' | 'medium' | 'small' | 'mini'

export interface AvatarProps {
  /** 头像图片 URL */
  src: string

  /** 用户昵称（用于 alt 属性） */
  nickname?: string

  /** 账号等级（直接传入） */
  accountLevel?: AccountLevelType

  /** 或者传入标签数组（会自动解析） */
  tags?: string[]

  /** 尺寸规格
   * - large: 80px (个人主页大头像)
   * - medium: 48px (创作者卡片)
   * - small: 32px (评论、@提及)
   * - mini: 24px (小卡片)
   */
  size?: AvatarSizeType

  /** 自定义头像大小（可选，覆盖 size），支持数字（默认px）或带单位的字符串（如 '3.6rem'） */
  avatarSize?: number | string

  /** 自定义标识大小（可选），支持数字（默认px）或带单位的字符串（如 '3.6rem'） */
  badgeSize?: number | string

  /** 用户 ID（用于点击跳转） */
  userId?: string | number

  /** 来源标识（用于埋点追踪，如 'ranking_board', 'feed_card' 等） */
  enterFrom?: string

  /** 是否可点击（默认 true，当 userId 存在时） */
  clickable?: boolean

  /** 自定义类名 */
  class?: string

  /** 是否显示 V 认证标识（默认 true） */
  isShowBadgeFlag?: boolean
}

/**
 * Avatar 尺寸配置
 */
export interface AvatarSizeConfig {
  /** 头像尺寸 */
  avatar: number
  /** V 认证标识尺寸 */
  badge: number
  /** V 认证标识 right 偏移量 */
  badgeOffsetRight: number
  /** V 认证标识 bottom 偏移量 */
  badgeOffsetBottom: number
}

/**
 * 尺寸配置映射表
 */
export const AVATAR_SIZE_MAP: Record<AvatarSizeType, AvatarSizeConfig> = {
  large: {
    avatar: 100,
    badge: 32,
    badgeOffsetRight: 0,
    badgeOffsetBottom: 0
  },
  medium: {
    avatar: 48,
    badge: 24,
    badgeOffsetRight: 0,
    badgeOffsetBottom: -3
  },
  small: {
    avatar: 36,
    badge: 14,
    badgeOffsetRight: -1,
    badgeOffsetBottom: -1
  },
  mini: {
    avatar: 20,
    badge: 9,
    badgeOffsetRight: -1,
    badgeOffsetBottom: -1
  }
}
